import { inject, Injectable } from '@angular/core';
import { HttpGetNotificacoes } from './notificacoes.type';
import { HttpClient } from '@angular/common/http';
import { from, Observable, Subject, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/services/base.service';

const API_URL = environment.apice.url;
const URL = environment.baseURL;

@Injectable({
  providedIn: 'root'
})
export class NotificacoesServiceService {

  private http = inject(HttpClient);
  private BS = inject(BaseService);

  public closeMenu$ = new Subject<void>();

  public buscaTodasNotificacoes = (): Observable<HttpGetNotificacoes> => {
    return this.http
      .get<HttpGetNotificacoes>(
        API_URL + 'notificacoes/busca-notificacoes',
        this.BS.getHeaders(true)
      )
      .pipe(
        switchMap(notificacoes => 
          from(this.verificaTarefasHoje(notificacoes))
        )
      );
  };

  async verificaTarefasHoje(
    notificacoes: HttpGetNotificacoes
  ): Promise<HttpGetNotificacoes> {

    try {
      const tarefas: any = await this.buscaTarefas();

      if (!tarefas || !tarefas.tarefasPendentedesHoje?.length) {
        return notificacoes;
      }

      for (const tarefa of tarefas.tarefasPendentedesHoje) {

        if (
          notificacoes.find(
            notificacao => notificacao?.descricao?.tarefaId === tarefa.id
          )
        ) {
          continue;
        }

        const bodyNotificacao = {
          titulo: tarefa.titulo,
          descricao: {
            texto: `${tarefa.descricao.replace('.', '') || "Tarefa sem descrição"}, hoje às ${
              new Date(tarefa.dataHoraIni)
                .toLocaleTimeString()
                .slice(0, 5)
            } horas`,
            img: "",
            link: `${URL}tarefas?tarefaId=${tarefa.id}`,
            tipo: 5,
            tarefaId: tarefa.id
          },
          dataIni: new Date(
            new Date().getTime() -
            new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 16),
          dataFim: new Date(
            new Date(tarefa.dataHoraIni).getTime() -
            new Date(tarefa.dataHoraIni).getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 16),
          filtro: {}
        };

        const novaTarefa = await this.criaNotificacaoUsuario(bodyNotificacao);

        notificacoes.push({ ...novaTarefa, ...bodyNotificacao } as any);
      }

      return notificacoes;

    } catch (error) {
      return notificacoes;
    }
  }

  criaNotificacaoUsuario(body) {
    return this.http
      .post(
        API_URL + 'notificacoes/post-notificacoes-usuario',
        body,
        this.BS.getHeaders(true)
      )
      .toPromise();
  }

  buscaTarefas() {
    return this.http
      .get(
        API_URL + `dashboard/tarefas?usuarioList=[]`,
        this.BS.getHeaders(true)
      )
      .toPromise();
  }

  public get tiposNotificacao(): {[key: number]: {txt: string, icon: string}} {
    return {
      1: {
        txt: "Mensagem",
        icon: 'email-outline'
      },
      2: {
        txt: "Atualização",
        icon: 'update'
      },
      3: {
        txt: "Alerta",
        icon: 'comment-alert-outline'
      },
      4: {
        txt: "Novidades",
        icon: 'newspaper-variant-outline'
      },
      5: {
        txt: "Tarefa",
        icon: 'menu-tarefas'
      }
    }
  }
}
